import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import mixpanel from "../../common/mixpanel-config";

export function MixpanelInitialize(): JSX.Element {
  const location = useLocation();

  useEffect(
    function onRouteChange() {
      mixpanel.track_pageview();
    },
    [location.pathname]
  );

  return <></>;
}
